import AgendaItemLocation from "@/domain/entities/agenda/AgendaItemLocation";
import { AgendaItemLocation as AgendaItemLocationSDK } from "@cs_teamwaydev/mailvista-sdk_react";

const agendaItemLocationToDomainMapper = (
    agendaItemLocation: AgendaItemLocationSDK,
): AgendaItemLocation =>
    new AgendaItemLocation({
        displayName: agendaItemLocation.displayName,
        locationType: agendaItemLocation.locationType,
        uniqueIdType: agendaItemLocation.uniqueIdType,
    });

export default agendaItemLocationToDomainMapper;
